import { Option } from 'types';

/**
 * Get pre-installed options for occasion based on the given options.
 *
 * @param {Option[]} options - An array of objects representing the options.
 * @returns {Option[]} An array of options that are pre-installed on the occasion.
 */
export const getPreInstalledForOccasion = (options: Option[]): Option[] => {
	// select options with a status of 'installed'
	const installed = options.filter(({ status }) => status === 'installed');

	// select if option is a towbar with a price of zero
	// since this means it is already installed on the car (according to the partner)
	const towbar = options.filter(
		({ monthPrice, description, status }) =>
			monthPrice === 0 && description.toLowerCase().includes('trekhaak') && status !== 'installed'
	);

	return [...installed, ...towbar];
};
